interface DateCellProps {
  value: string | Date;
  format?: 'date' | 'time' | 'both';
  showDay?: boolean;
}

const DateCell = ({
  value,
  format = 'date',
  showDay = false,
}: DateCellProps) => {
  /*
   - value - The date/time value to be formatted.
   - format (string, optional) - Determines what to display:
      - date (default) → Shows only the date (12-02-2025).
      - time → Shows only the time (2:30 PM).
      - both → Shows both date and time (12-02-2025, 2:30 PM).
   - showDay (boolean, optional) - If `true`, displays the day (Fri, 12-02-2025).
  */

  const dateTime = new Date(value);

  // Handle invalid dates
  if (isNaN(dateTime.getTime())) {
    return <div>Invalid date</div>;
  }

  const formattedDay = dateTime.toLocaleDateString('en-GB', {
    weekday: 'short',
  });

  const formattedDate = dateTime
    .toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    .replace(/\//g, '-');

  const formattedTime = dateTime.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  // Build the final display text based on props
  let displayText = '';

  if (format === 'date') {
    displayText = showDay ? `${formattedDay}, ${formattedDate}` : formattedDate;
  } else if (format === 'time') {
    displayText = formattedTime;
  } else {
    displayText = showDay
      ? `${formattedDay}, ${formattedDate}, ${formattedTime}`
      : `${formattedDate}, ${formattedTime}`;
  }

  return <>{displayText}</>;
};

export { DateCell };
